import { Card } from "../../../../../components/Card";
import { Text } from "@chakra-ui/react";

function CarbonPriceDescription() {
  return (
    <Card>
      <Text marginBottom={5}>
        Carbon pricing is a cost applied to carbon emissions (and other greenhouse gases – CO2e). It is utilised an instrument to encourage reductions in GHG emissions. Carbon prices indicate the extent to which countries are placing more pressure on decarbonising.
      </Text>
      <Text marginBottom={5}>
        Tracking carbon prices is essential for better preparedness in terms of market fluctuations and how this may affect your operations/ supply chain. Carbon prices vary across the globe due to different carbon pricing schemes (e.g., the European Union's Emission Trading Scheme (ETS) and different approaches (cap-and-trade or a carbon tax).
      </Text>
      <Text marginBottom={5}>
        The carbon price is likely to fall between the market price (refer to EMBER) and the social cost of carbon (refer to Gov.uk), however it is important to note that there is currently no globally agreed carbon price.
      </Text>
      <Text>
        Across the globe, there is a growing number of carbon pricing schemes evolving and being enforced. As there is much variability of carbon prices, based on market conditions and location, carbon price can be tracked through multiple sources.
      </Text>
    </Card>
  )
}

export default CarbonPriceDescription;